import React from "react";
import OverlayContainer from "./OverlayContainer";
import IntroContent from "./IntroContent";
import Feedback from "./Feedback";
import Privacy from "./Privacy";
import Terms from "./Terms";
import AddTaskForm from "./AddTaskForm";
import ExportTasksModal from "./ExportTasksModal";
import RecurringModal from "./RecurringModal";

const OverlayManager = ({ overlayContent, handleOverlayClose }) => {
  if (!overlayContent) return null;

  return (
    <OverlayContainer isOpen={!!overlayContent} onClose={handleOverlayClose}>
      {overlayContent === "intro" && <IntroContent loggedIn={true} />}
      {overlayContent === "feedback" && <Feedback />}
      {overlayContent === "privacy" && <Privacy />}
      {overlayContent === "terms" && <Terms />}
      {overlayContent === "addTask" && <AddTaskForm />}
      {overlayContent === "exportTasks" && (
        <ExportTasksModal onClose={handleOverlayClose} />
      )}
      {overlayContent === "recurring" && (
        <RecurringModal onClose={handleOverlayClose} />
      )}
    </OverlayContainer>
  );
};

export default OverlayManager;
